module.exports = __webpack_public_path__ + "img/01-mexican.1fb5d15a.svg";